import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-2xl  font-nunito700',
  {
    variants: {
      variant: {
        lime: 'bg-lime-200 text-black',
        teal: 'bg-deep-teal-100 text-black',
        grey: 'bg-grey-50 text-black',
        red: 'bg-red-300 text-black',
        yellow: 'bg-yellow-200 text-black',
        black: 'bg-black text-white',
        darkTeal: 'bg-deep-teal-500 text-spearmint-500',
        greenOutline: 'border border-green-500 text-black',
        tealOutline: 'border border-deep-teal-500 text-black',
        greyOutline: 'border border-grey-200 text-black',
        redOutline: 'border border-status-danger text-black',
        yellowOutline: 'border border-status-warning text-black',
        blackOutline: 'border border-grey-900 text-black',
      },
      size: {
        xlarge: 'px-4 py-1 text-lg',
        large: 'px-[0.75rem] py-[0.125rem] text-base',
        medium: 'px-2 py-[0.125rem] text-xs min-h-[18px]',
        small: 'px-2 py-[0.125rem] text-xxs min-h-[18px]',
      },
    },
    defaultVariants: {
      variant: 'lime',
      size: 'small',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {
  children: React.ReactNode;
}

function Badge({
  className,
  variant = 'lime',
  size = 'small',
  children,
  ...props
}: BadgeProps) {
  return (
    <div
      className={cn(badgeVariants({ variant, size }), className)}
      {...props}
      aria-label="Badge"
    >
      {children}
    </div>
  );
}

export { Badge, badgeVariants };
